import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authApi } from '../services/auth_endpoints';
import { selectUser } from '../selectors/users';

const DEMO_ALLOWED = [
  /^\/customers\/\d+\/events\/\d+/,
  /^\/events\/\d+/,
  /^\/demo$/,
];

const isAllowedForDemo = (pathname) =>
  DEMO_ALLOWED.some((pattern) => pattern.test(pathname));

export const useDemoGuard = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  useEffect(() => {
    if (user?.demo && !isAllowedForDemo(location.pathname)) {
      // Clear the client session (demo users are ephemeral). upsert avoids a
      // refetch that would re-hydrate the demo user from its cookie.
      dispatch(authApi.util.upsertQueryData('getCurrentUser', undefined, null));
    }
  }, [location.pathname, user?.demo, dispatch]);
};
